module.exports = __webpack_public_path__ + "img/arrow-down.a1becc2b.svg";